import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import { createAd } from '../../../../../../modules/actions/ads'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'

import { rightSelector } from '../../../../../../modules/selectors/rights'
import { selfAccountSelector } from '../../../../../../modules/selectors/selfAccounts'
import { selectedPartnershipSelector } from '../../../../../../modules/selectors/partnerships'

import { transformImageValuesToBE, transformVideoValuesToBE } from '../formatters'

import { IMAGE_UPLOAD_TYPE, getInitialValues } from '../fields'
import { validationSchema } from '../validation'

import { GOOGLE_AD_MANAGER_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { GAM_NETWORK_CODE } from '../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/fields'
import { GOOGLE_AD_MANAGER_AD_ACCOUNT } from '../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

// todo integrate internal ad creation
export function useCreateGamAd({ isInternalAdCreation, formatOption }) {
  const dispatch = useDispatch()

  const right = useSelector(rightSelector)
  const selfAccount = useSelector(selfAccountSelector)
  const selectedPartnership = useSelector(selectedPartnershipSelector)

  const { [GOOGLE_AD_MANAGER_AD_ACCOUNT]: gamAccount } = selectedPartnership
  const gamAccountId = gamAccount?.external_id
  const gamNetworkCode = selfAccount?.[GAM_NETWORK_CODE]

  const onSubmit = useCallback(
    values => {
      const transformedCreativeValues =
        formatOption === IMAGE_UPLOAD_TYPE
          ? transformImageValuesToBE({ values, gamAccountId, right })
          : transformVideoValuesToBE({ values, gamAccountId, right })

      dispatch(
        createAd(
          {
            network_code: gamNetworkCode,
            save_to_database: false, // default false
            creatives: transformedCreativeValues
          },
          GOOGLE_AD_MANAGER_PLATFORM
        )
      )
    },
    [dispatch, formatOption, gamAccountId, gamNetworkCode, right]
  )

  const initialValues = useMemo(
    () => getInitialValues(formatOption, isInternalAdCreation),
    [formatOption, isInternalAdCreation]
  )

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  return useMemo(
    () => ({
      purifiedFormik
    }),
    [purifiedFormik]
  )
}
